<script lang="ts">
	import SignUpForm from 'src/components/Profiles/SignUpForm.svelte';
	import { push } from 'svelte-spa-router';
</script>

<SignUpForm
	idPrefix="signup"
	testIdPrefix="signUp"
	showLangDropdown={false}
	on:registered={() => push('/login')}
	on:close={() => push('/login')}
/>
